/* unplugin-vue-components disabled */import { render } from "./detail.vue?vue&type=template&id=b5cc6698&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=b5cc6698&scoped=true&lang=scss"
import "./detail.vue?vue&type=style&index=1&id=b5cc6698&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5cc6698"]])

export default __exports__